// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3I4d7","loyalty-inner-text":"_1QTmO","loyaltyInnerText":"_1QTmO","second-line":"_2nXJm","secondLine":"_2nXJm"};